import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { heroSlides } from '@/mocks/mangas';

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((a) => (a + 1) % heroSlides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative h-[560px] md:h-[600px] w-full overflow-hidden" aria-label="主打漫画推荐">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === active ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src={slide.cover}
            alt={`${slide.title} 主视觉 - 樱花漫画网`}
            title={`${slide.title} - 本周主打`}
            className="h-full w-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>

      {/* Center content */}
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-4 text-center">
        <span className="rounded-full bg-primary-500/90 px-4 py-1 text-xs font-medium text-background-50 md:text-sm">
          {heroSlides[active].tag}
        </span>
        <h1
          key={heroSlides[active].id}
          className="font-heading mt-5 animate-[fadeUp_.6s_ease] text-4xl font-bold text-background-50 md:text-6xl"
        >
          {heroSlides[active].title}
        </h1>
        <p className="mt-3 max-w-2xl animate-[fadeUp_.6s_ease_.1s] text-base text-background-100 md:text-xl">
          {heroSlides[active].desc}
        </p>

        {/* Search */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const q = searchTerm.trim();
            navigate(q ? `/category/all?q=${encodeURIComponent(q)}` : '/category/all');
          }}
          className="mt-8 flex w-full max-w-xl items-center gap-2 rounded-full bg-background-50/95 p-1.5 pl-5 shadow-lg"
          role="search"
        >
          <i className="ri-search-line text-lg text-foreground-500"></i>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="输入漫画名，比如：樱之夏、花火纪元…"
            className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-sm placeholder:text-foreground-400"
          />
          <button
            type="submit"
            className="rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition hover:bg-primary-600"
          >
            搜索漫画
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/category/new"
            className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition hover:bg-accent-600"
          >
            <i className="ri-flashlight-fill"></i>
            同步追更新番
          </Link>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 rounded-full border border-background-50/60 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition hover:bg-background-50 hover:text-foreground-900"
          >
            浏览全部漫画
          </Link>
        </div>
      </div>

      {/* Controls */}
      <div className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2">
        {heroSlides.map((s, i) => (
          <button
            key={s.id}
            type="button"
            aria-label={`切换到 ${s.title}`}
            onClick={() => setActive(i)}
            className={`h-2 rounded-full transition-all duration-300 ${
              i === active ? 'w-7 bg-primary-400' : 'w-2 bg-background-50/60 hover:bg-background-50'
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}